export const httpClientConfig = {
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: Number(process.env.VUE_APP_REQUEST_TIMEOUT) || 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
};
